import { render, staticRenderFns } from "./explain-search.view.vue?vue&type=template&id=55833fca&scoped=true"
import script from "./explain-search.view.vue?vue&type=script&lang=ts"
export * from "./explain-search.view.vue?vue&type=script&lang=ts"
import style0 from "./explain-search.view.vue?vue&type=style&index=0&id=55833fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55833fca",
  null
  
)

export default component.exports